// App.js — SEO OPTIMIZED FOR neuroui.pro
import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, setDoc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";

import Auth from "./components/Auth";
import Tools from "./components/Tools";
import Favorites from "./components/Favorites";
import Logo from "./img/logo.png";
import liveTool from "./img/livetool.gif";
import fontTool from "./img/fonttool.gif";
import gradientTool from "./img/gradienttool.gif";
import pickerTool from "./img/pickertool.gif";
import buttonTool from "./img/buttontool.gif";
import paletteTool from "./img/palettetool.gif";
import "./App.css";

// Глобальный тост
window.showToast = (msg, type = "info") => {
  window.dispatchEvent(new CustomEvent("showToast", { detail: { msg, type } }));
};

const translations = {
  ru: {
    siteName: "NeuroUI.pro",
    title: "Бесплатные CSS генераторы: градиенты, тени, кнопки, палитры",
    description: "5+ мощных CSS-инструментов для дизайнеров: генераторы градиентов, цветовых палитр, кнопок, glassmorphism, неон, live-превью. Сохраняйте стили в облако.",
    
    tools: "Инструменты",
    info: "Руководство",
    profile: "Профиль",
    login: "Вход",
    favorites: "Избранное",
    addFavorite: "Сохранить",
    selectStyle: "Сначала выберите стиль!",
    toastLogin: "Войдите, чтобы сохранять!",
    toastLimit: "Максимум 5 стилей!",
    toastExists: "Уже в избранном!",
    toastAdded: "Добавлено!",
    toastRemoved: "Удалено",
    toastApplied: "Применено!",
    cookieText: "Этот сайт использует файлы cookie для улучшения работы. Мы храним только технические данные и предпочтения языка.",
    cookieMore: "Подробнее",
    accept: "Принять всё",
    reject: "Отклонить",
    cookiePolicy: "Политика конфиденциальности",
    close: "Закрыть",

    bannerTitle: `<h3>&nbsp; Создавайте стильные <br />веб-дизайны в один клик c neuroui.pro</h3> <br>
                  &nbsp; Генерируйте оформление за секунды на любом устройстве и cохраняйте готовые пресеты в избранное
               `,

    infoText: `
      <h3> &nbsp; Руководство по использованию Neuro UI</h3><br>
      
      <p> &nbsp; Live Preview — это можно назвать основная рабочая зона, где можно сразу создать уникальную страницу с готовым визуальным стилем.</p><br/>
      <img style="width: 100%; border-radius: 30px; margin: 10px" src=${liveTool}>
      <p> &nbsp; В инструменте Live Preview моментально отображается результат сгенерированной или созданной пользователем страницы. Так же 
      в нём можно редактировать код HTML и CSS, в несколько кликов создавая уникальный дизайн.</p> <br/>

      <h3> &nbsp; Инструменты Neuro UI:</h3><br/>

            <p><strong> &nbsp; Подбор шрифтов</strong><br><br>
                                  <img style="width: 100%; border-radius: 30px; margin: 10px" src=${fontTool}>
                  Cамые стильные Google Fonts с живым превью и готовым кодом font-family. Изначально вы должны убидится , что у вас подключены шрифты Google.</p> <br/><br/>


      <p><strong> &nbsp; Генератор градиентов</strong><br><br/>
                            <img style="width: 100%; border-radius: 30px; margin: 10px" src=${gradientTool}> 
      Тысячи красивых линейных и радиальных градиентов одним кликом + кнопка случайной генерации. Нажмите на кнопку с настройками градиента, что бы копировать код.</p><br/><br/>


      <p><strong> &nbsp; Генератор цветовых палитр</strong><br><br/>
                             <img style="width: 100%; border-radius: 30px; margin: 10px" src=${paletteTool}> 
      Гармоничные 6-цветные палитры по HSL-модели — нажмите на хэш и сразу скопируйте</p><br/><br/>


      <p><strong> &nbsp; Профессиональный цветовой пикер</strong><br><br/>
                            <img style="width: 100%; border-radius: 30px; margin: 10px" src=${pickerTool}> 
      Полноценная HSV-палитра с ползунком тона — выбирайте любой оттенок с точностью до пикселя. Нажмите на любой цвет, что бы скопировать его хэш код.</p><br/><br/>



      <p><strong> &nbsp; Генератор кнопок</strong><br><br/>
                           <img style="width: 100%; border-radius: 30px; margin: 10px" src=${buttonTool}>
      Настраивайте градиент, скругление, тени, шрифт и hover-эффекты — получайте готовую кнопку за секунды.</p><br/><br/>




      <p><strong>Облачное избранное</strong><br><br/>

      Сохраняйте до 5 любимых комбинаций (шрифт + цвета + градиент + кнопка) после быстрого входа через Google</p><br/>

      <p style="margin-top:40px;">Работает офлайн (PWA), идеально под смартфоны и планшеты, мгновенное копирование кода в один клик.</p><br/>
      
      <p><strong>Создавайте уникальный дизайн за секунды — просто выбирайте, копируйте и вставляйте в свой проект!</strong></p><br/>
    `,

    footer: "2025 © NeuroUI.pro | Бесплатные CSS инструменты для дизайнеров",
  },

  uk: {
    siteName: "NeuroUI.pro",
    title: "Безкоштовні CSS генератори: градієнти, тіні, кнопки, палітри",
    description: "5+ потужних CSS-інструментів для дизайнерів: генератори градієнтів, палітр, кнопок, glassmorphism, неон, live-превʼю. Зберігайте стилі в хмарі.",

    tools: "Інструменти",
    info: "Довідка",
    profile: "Профіль",
    login: "Увійти",
    favorites: "Обране",
    addFavorite: "В обране",
    selectStyle: "Спочатку оберіть стиль!",
    toastLogin: "Увійдіть, щоб зберігати!",
    toastLimit: "Максимум 5 стилів!",
    toastExists: "Вже в обраному!",
    toastAdded: "Додано!",
    toastRemoved: "Видалено",
    toastApplied: "Застосовано!",
    cookieText: "Цей сайт використовує файли cookie для покращення роботи. Ми зберігаємо лише технічні дані та мовні налаштування.",
    cookieMore: "Детальніше",
    accept: "Прийняти все",
    reject: "Відхилити",
    cookiePolicy: "Політика конфіденційності",
    close: "Закрити",

    bannerTitle: `<h3> &nbsp; Створюйте стильні <br />веб-дизайни в один клік з neuroui.pro</h3><br/>
                  &nbsp; Генеруйте оформлення за секунди на будь-якому пристрої. 
                  Зберігайте готові пресети в обране.`,

    infoText: `
      <h3> &nbsp; Керівництво з використання Neuro UI</h3><br>
      
      <p> &nbsp; Live Preview — це можна назвати основною робочою зоною, де можна одразу створити унікальну сторінку з готовим візуальним стилем.</p><br/>
      <img style="width: 100%; border-radius: 30px; margin: 10px" src=${liveTool}>
      <p> &nbsp; У інструменті Live Preview миттєво відображається результат згенерованої або створеної користувачем сторінки. Також 
      в ньому можна редагувати код HTML і CSS, за кілька кліків створюючи унікальний дизайн.</p> <br/>

      <h3>Інструменти Neuro UI:</h3><br/>

            <p><strong> &nbsp; Підбір шрифтів</strong><br><br>
                                  <img style="width: 100%; border-radius: 30px; margin: 10px" src=${fontTool}> 
                  Найстильніші Google Fonts з живим прев’ю та готовим кодом font-family. Спочатку вам потрібно переконатися, що у вас підключені шрифти Google.</p> <br/><br/>



      <p><strong> &nbsp; Генератор градієнтів</strong><br><br/>
                            <img style="width: 100%; border-radius: 30px; margin: 10px" src=${gradientTool}> 
      Тисячі красивих лінійних та радіальних градієнтів одним кліком + кнопка випадкової генерації. Натисніть на кнопку з налаштуваннями градієнта, щоб скопіювати код.</p><br/><br/>


      <p><strong> &nbsp; Генератор кольорових палітр</strong><br><br/>
                             <img style="width: 100%; border-radius: 30px; margin: 10px" src=${paletteTool}> 
      Гармонійні 6-кольорові палітри за HSL-моделлю — натисніть на хеш і одразу скопіюйте</p><br/><br/>


      <p><strong> &nbsp; Професійний колірний пікер</strong><br><br/>
                            <img style="width: 100%; border-radius: 30px; margin: 10px" src=${pickerTool}> 
      Повноцінна HSV-палітра з повзунком тону — обирайте будь-який відтінок з точністю до пікселя. Натисніть на будь-який колір, щоб скопіювати його хеш-код.</p><br/><br/>



      <p><strong> &nbsp; Генератор кнопок</strong><br><br/>
                           <img style="width: 100%; border-radius: 30px; margin: 10px" src=${buttonTool}> 
            Налаштовуйте градієнт, скруглення, тіні, шрифт та hover-ефекти — отримуйте готову кнопку за секунди.</p><br/>




      <p><strong>Хмарне обране</strong><br><br/>

      Зберігайте до 5 улюблених комбінацій (шрифт + кольори + градієнт + кнопка) після швидкого входу через Google</p><br/>

      <p style="margin-top:40px;">Працює офлайн (PWA), ідеально для смартфонів і планшетів, миттєве копіювання коду одним кліком.</p><br/>
      
      <p><strong>Створюйте унікальний дизайн за секунди — просто обирайте, копіюйте та вставляйте у свій проект!</strong></p><br/>
    `,


    footer: "2025 © NeuroUI.pro | Безкоштовні CSS інструменти для дизайнерів",
  },

  en: {
    siteName: "NeuroUI.pro",
    title: "Free CSS Generators: Gradients, Buttons, Palettes, Shadows",
    description: "5+ powerful CSS tools for designers: gradient generator, color palettes, buttons, glassmorphism, neon, live preview. Save styles to cloud.",

    tools: "Tools",
    info: "Guide",
    profile: "Profile",
    login: "Login",
    favorites: "Favorites",
    addFavorite: "Save",
    selectStyle: "Select a style first!",
    toastLogin: "Log in to save!",
    toastLimit: "Max 5 styles!",
    toastExists: "Already saved!",
    toastAdded: "Saved!",
    toastRemoved: "Removed",
    toastApplied: "Applied!",
    cookieText: "This site uses cookies to improve your experience. We store only technical data and language preferences.",
    cookieMore: "Learn more",
    accept: "Accept all",
    reject: "Decline",
    cookiePolicy: "Privacy Policy",
     close: "Close",

    bannerTitle: `<h3> &nbsp; Create stylish <br />web designs in one click with neuroui.pro</h3><br/>
                  &nbsp; Generate beautiful UI elements in seconds on any device. 
                  Save your favorite presets to favorites.`,

infoText: `
      <h3> &nbsp; Neuro UI User Guide</h3><br>
      
      <p> &nbsp; Live Preview — this can be called the main workspace, where you can immediately create a unique page with a ready-made visual style.</p><br/>
      <img style="width: 100%; border-radius: 30px; margin: 10px" src=${liveTool}>
      <p> &nbsp; In the Live Preview tool, the result of the generated or user-created page is displayed instantly. You can also edit the HTML and CSS code, creating a unique design in just a few clicks.</p> <br/>

      <h3> &nbsp; Neuro UI Tools:</h3><br/>

            <p> <strong>Font Selector</strong><br><br>
                                  <img style="width: 100%; border-radius: 30px; margin: 10px" src=${fontTool}> 
                  The most stylish Google Fonts with live preview and ready-to-use font-family code. First, make sure you have Google Fonts connected.</p> <br/><br/>



      <p><strong> &nbsp; Gradient Generator</strong><br><br/>
                            <img style="width: 100%; border-radius: 30px; margin: 10px" src=${gradientTool}> 
      Thousands of beautiful linear and radial gradients with one click + a random generation button. Click the gradient settings button to copy the code.</p><br/><br/>


      <p><strong> &nbsp; Color Palette Generator</strong><br><br/>
                             <img style="width: 100%; border-radius: 30px; margin: 10px" src=${paletteTool}>
      Harmonious 6-color palettes based on the HSL model — click on the hash to copy it immediately.</p><br/><br/>


      <p><strong> &nbsp; Professional Color Picker</strong><br><br/>
                            <img style="width: 100%; border-radius: 30px; margin: 10px" src=${pickerTool}> 
      Full HSV palette with hue slider — choose any shade with pixel-perfect accuracy. Click on any color to copy its hex code.</p><br/><br/>



      <p><strong> &nbsp; Button Generator</strong><br><br/>
                           <img style="width: 100%; border-radius: 30px; margin: 10px" src=${buttonTool}>
      Customize gradient, border radius, shadows, font, and hover effects — get a ready-made button in seconds.</p><br/>



      <p><strong> &nbsp; Cloud Favorites</strong><br><br/>
      Save up to 5 favorite combinations (font + colors + gradient + button) after quick login via Google.</p><br/>

      <p style="margin-top:40px;">Works offline (PWA), perfect for smartphones and tablets, instant code copying with one click.</p><br/>
      
      <p><strong>Create a unique design in seconds — just choose, copy, and paste into your project!</strong></p><br/>
    `,


    footer: "2025 © NeuroUI.pro | Free CSS Tools for Designers",
  },
};

export default function App() {
  const [view, setView] = useState("tools");
  const [user, setUser] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [toast, setToast] = useState(null);
  const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);
  const [cookiesAccepted, setCookiesAccepted] = useState(null);
  const [banner, setBanner] = useState(true);

  // Определяем язык
  const getInitialLang = () => {
    const saved = localStorage.getItem("lang");
    if (saved && ["ru", "uk", "en"].includes(saved)) return saved;

    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith("uk")) return "uk";
    if (browserLang.startsWith("en")) return "en";
    return "ru";
  };

  const [lang, setLang] = useState(getInitialLang());
  const t = translations[lang];

  // Сохранение языка
  const changeLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem("lang", newLang);
    // Обновляем URL без перезагрузки
    const url = new URL(window.location);
    url.searchParams.set('lang', newLang);
    window.history.replaceState({}, '', url);
  };

  // === SEO OPTIMIZATION ===
  useEffect(() => {
    // Title
    document.title = `${t.title} | ${t.siteName}`;

    // Удаляем старые SEO теги
    document.querySelectorAll("meta[data-seo]").forEach((el) => el.remove());
    document.querySelectorAll("link[rel='alternate']").forEach((el) => el.remove());
    document.getElementById("json-ld")?.remove();
    document.getElementById("breadcrumb-ld")?.remove();

    // Основные мета-теги
    const metaTags = [
      // Основные
      { name: "description", content: t.description },
      { name: "keywords", content: "css generator, gradient generator, button generator, color palette, web design tools, free css, neuroui" },
      { name: "author", content: "NeuroUI.pro" },
      { name: "robots", content: "index, follow, max-image-preview:large" },
      { name: "theme-color", content: "#1a1a1a" },
      { name: "viewport", content: "width=device-width, initial-scale=1.0" },
      
      // Open Graph
      { property: "og:title", content: `${t.title} | ${t.siteName}` },
      { property: "og:description", content: t.description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://neuroui.pro" },
      { property: "og:image", content: "https://neuroui.pro/og-image.jpg" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:locale", content: lang === "uk" ? "uk_UA" : lang === "en" ? "en_US" : "ru_RU" },
      { property: "og:site_name", content: t.siteName },
      
      // Twitter
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: `${t.title} | ${t.siteName}` },
      { name: "twitter:description", content: t.description },
      { name: "twitter:image", content: "https://neuroui.pro/og-image.jpg" },
      { name: "twitter:creator", content: "@neuroui" },
      
      // Additional
      { name: "apple-mobile-web-app-capable", content: "yes" },
      { name: "apple-mobile-web-app-status-bar-style", content: "black" },
    ];

    metaTags.forEach((m) => {
      const tag = document.createElement("meta");
      Object.entries(m).forEach(([key, value]) => tag.setAttribute(key, value));
      tag.setAttribute("data-seo", "true");
      document.head.appendChild(tag);
    });

    // Языковые альтернативы (hreflang)
    ["ru", "uk", "en"].forEach((l) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = l === "uk" ? "uk" : l;
      link.href = `https://neuroui.pro/?lang=${l}`;
      document.head.appendChild(link);
    });
    
    // Дефолтный язык
    const linkDefault = document.createElement("link");
    linkDefault.rel = "alternate";
    linkDefault.hreflang = "x-default";
    linkDefault.href = "https://neuroui.pro/";
    document.head.appendChild(linkDefault);

    // JSON-LD структурированные данные
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: t.siteName,
      url: "https://neuroui.pro",
      description: t.description,
      applicationCategory: "DesignApplication",
      operatingSystem: "Any",
      browserRequirements: "Requires JavaScript. Requires HTML5.",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD"
      },
      inLanguage: lang === "uk" ? "uk" : lang,
      screenshot: "https://neuroui.pro/screenshot.jpg",
      creator: {
        "@type": "Organization",
        name: "NeuroUI",
        url: "https://neuroui.pro"
      }
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "json-ld";
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    // Breadcrumb structured data
    const breadcrumbLd = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://neuroui.pro"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": view === "tools" ? "Tools" : view === "info" ? "About" : "Login",
          "item": `https://neuroui.pro/#${view}`
        }
      ]
    };

    const breadcrumbScript = document.createElement("script");
    breadcrumbScript.type = "application/ld+json";
    breadcrumbScript.id = "breadcrumb-ld";
    breadcrumbScript.textContent = JSON.stringify(breadcrumbLd);
    document.head.appendChild(breadcrumbScript);

    // Канонический URL
    let linkCanonical = document.querySelector("link[rel='canonical']");
    if (!linkCanonical) {
      linkCanonical = document.createElement("link");
      linkCanonical.rel = "canonical";
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.href = `https://neuroui.pro/?lang=${lang}`;

  }, [lang, t, view]);

  // Cookie consent
  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    setCookiesAccepted(accepted !== null ? accepted === "true" : null);
    
    // Если пользователь не принял куки, удаляем все куки кроме языка
    if (accepted === "false") {
      // Сохраняем только язык
      const langValue = localStorage.getItem("lang");
      localStorage.clear();
      if (langValue) localStorage.setItem("lang", langValue);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setCookiesAccepted(true);
  };

  const handleRejectCookies = () => {
    localStorage.setItem("cookiesAccepted", "false");
    setCookiesAccepted(false);
    // Удаляем все куки кроме языка
    const langValue = localStorage.getItem("lang");
    localStorage.clear();
    if (langValue) localStorage.setItem("lang", langValue);
  };

  // Open privacy policy
  const openPrivacyPolicy = () => {
    window.open('/privacy', '_blank');
  };

  // Auth & Favorites
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
      if (u) {
        loadFavorites(u.uid);
      } else {
        setFavorites([]);
      }
    });
    return unsub;
  }, []);

  const loadFavorites = async (uid) => {
    try {
      const ref = doc(db, "favorites", uid);
      const snap = await getDoc(ref);
      setFavorites(snap.exists() ? snap.data().list || [] : []);
    } catch (err) {
      console.error(err);
    }
  };

  const saveFavorite = async (fav) => {
    if (!user) return window.showToast(t.toastLogin, "error");
    if (favorites.length >= 5) return window.showToast(t.toastLimit, "error");
    if (favorites.some(f => JSON.stringify(f) === JSON.stringify(fav)))
      return window.showToast(t.toastExists, "info");

    try {
      await updateDoc(doc(db, "favorites", user.uid), { list: arrayUnion(fav) });
      setFavorites(prev => [...prev, fav]);
      window.showToast(t.toastAdded, "success");
    } catch {
      window.showToast("Ошибка сохранения", "error");
    }
  };

  const deleteFavorite = async (fav) => {
    if (!user) return;
    try {
      await updateDoc(doc(db, "favorites", user.uid), { list: arrayRemove(fav) });
      setFavorites(prev => prev.filter(f => JSON.stringify(f) !== JSON.stringify(fav)));
      window.showToast(t.toastRemoved, "info");
    } catch {
      window.showToast("Ошибка удаления", "error");
    }
  };

  const applyFavorite = (fav) => {
    window.dispatchEvent(new CustomEvent("applyFavorite", { detail: fav }));
    window.showToast(t.toastApplied, "success");
  };

  // Toast
  useEffect(() => {
    const handler = (e) => setToast({ ...e.detail, id: Date.now() });
    window.addEventListener("showToast", handler);
    return () => window.removeEventListener("showToast", handler);
  }, []);

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(null), 3200);
    return () => clearTimeout(timer);
  }, [toast]);

  // Определяем активный язык для переключателя
  const activeLang = lang;

  return (
    <div className="app" lang={lang === "uk" ? "uk" : lang}>

             <header className="header">
             <div style={{display:"flex", alignItems:"center"}}>
          <img src={Logo} alt={`${t.siteName} Logo`} className="logo" width="80px" height="80px" />
          <h3 style={{padding:"10px", margin:"10px"}}>Neuro Ui</h3>
        </div>

      {/* Навигация */}
      <div className="navigation">
        <div className="nav-menu">
          <button onClick={() => setView("tools")} className={`nav-btn ${view === "tools" ? "active" : ""}`}>
            {t.tools}
          </button>

          <button onClick={() => setView("info")} className={`nav-btn ${view === "info" ? "active" : ""}`}>
            {t.info}
          </button>

          <button onClick={() => setView("auth")} className={`nav-btn ${view === "auth" ? "active" : ""}`}>
            {user ? t.profile : t.login}
          </button>

      {view === "tools" && <div style={{display:"flex"}}>

          {/* Добавить в избранное */}
          <button
            style={{}}
            onClick={() => {
              const fav = window.currentFavorite;
              if (fav) saveFavorite(fav);
              else window.showToast(t.selectStyle, "info");
            }}
            aria-label={t.addFavorite}
          >
            + {t.addFavorite}
          </button>

          {/* Избранное */}
          {user && favorites.length > 0 && (
            <button
              onClick={() => setIsFavoritesOpen(!isFavoritesOpen)}
              className={`nav-btn fav ${isFavoritesOpen ? "active" : ""}`}
              aria-label={t.favorites}
            >
              {t.favorites}: {favorites.length}
            </button>
          )}
</div>}  </div> </div>   



      <div style={{zIndex:"2100"}} role="region" aria-label="Language selector">
        
            <button style={{background:"rgba(1, 1, 1, 0)"}}
              onClick={() => changeLang("uk")} 
              className={activeLang === "uk" ? "active" : ""}
              aria-label="Українська мова"
              aria-current={activeLang === "uk" ? "true" : "false"}
            >
              УКР
            </button>

            <button  style={{background:"rgba(1, 1, 1, 0)"}}
              onClick={() => changeLang("ru")} 
              className={activeLang === "ru" ? "active" : ""}
              aria-label="Русский язык"
              aria-current={activeLang === "ru" ? "true" : "false"}
            >
              РУ
            </button>
            
                     <button style={{background:"rgba(1, 1, 1, 0)"}}
              onClick={() => changeLang("en")} 
              className={activeLang === "en" ? "active" : ""}
              aria-label="English language"
              aria-current={activeLang === "en" ? "true" : "false"}
             
            >
              EN
            </button>


   
          </div>   </header>

      {/* Всплывающее избранное */}
      {user && isFavoritesOpen && (
        <div className="favorites-floating" role="dialog" aria-label={t.favorites}>
          <Favorites favorites={favorites} applyFavorite={applyFavorite} deleteFavorite={deleteFavorite} />
        </div>
      )}

      {/* Баннер */}
{view === "tools" && banner===true && ( <div className="banner" role="banner">
        <div className="banner-text" dangerouslySetInnerHTML={{ __html: t.bannerTitle }} />
               <div style={{margin:"10px"}}>
          <button onClick={() => setView("info")} style={{background:"rgba(231, 185, 0, 1)", color:"black", boxShadow: "none", fontSize:"12px", borderRadius:"13px", animation: "dance 3s infinite" }}>
            {t.info}
          </button>
                   <button style={{background:"rgba(1, 1, 1, 0)", color:"white", boxShadow: "none", fontSize:"12px", fontWeight:"700"}} onClick={() => setBanner(false)}>
            {t.close}
          </button> </div>
      </div>) }

      {/* Контент */}
      <main className="main-content" role="main">
        {view === "auth" && <Auth user={user} setView={setView} />}
        {view === "info" && (
          <article className="info-card" dangerouslySetInnerHTML={{ __html: t.infoText }} />
        )}
        {view === "tools" && <Tools user={user} saveFavorite={saveFavorite} />}
      </main>

      {/* Тост */}
      {toast && (
        <div 
          className={`toast ${toast.type}`} 
          role="alert" 
          aria-live="polite"
          aria-atomic="true"
        >
          {toast.msg}
        </div>
      )}

      {/* Cookie Banner - Соответствует GDPR */}
      {cookiesAccepted === null && (
        <div role="dialog" aria-label="Cookie consent">
          <div style={{background:"rgba(1, 1 ,1, 0.7)",position:"fixed", bottom:"10px", display:"flex", margin:"0 auto", padding:"10px", transform:"translateX(-50%)", zIndex:"2000", borderRadius:"20px"}}>
            <p>{t.cookieText}</p>
            <div className="cookie-buttons">
              <button 
                onClick={handleAcceptCookies} 
                className="cookie-btn accept"
                aria-label={t.accept}
              >
                {t.accept}
              </button>
              <button 
                onClick={handleRejectCookies} 
                className="cookie-btn reject"
                aria-label={t.reject}
              >
                {t.reject}
              </button>
              <button 
                onClick={openPrivacyPolicy} 
                className="cookie-btn more"
                aria-label={t.cookieMore}
              >
                {t.cookieMore}
              </button>
            </div>
          </div>
        </div>
      )}

      <footer className="footer" role="contentinfo">
        {t.footer}
      </footer>
    </div>
  );
}
